import ApiService from "@/core/services/api.service";

// action types
export const FETCH_CATEGORIES = "fetchCategories";

// mutation types
export const SET_CATEGORIES = "setCategories";
export const SET_CATEGORIES_LOADING = "setCategoriesLoading";
export const SET_CATEGORIES_ERROR = "setCategoriesError";

const state = {
  categories: [],
  loading: false,
  error: null,
};

const getters = {
  categories(state) {
    return state.categories;
  },
  categoriesLoading(state) {
    return state.loading;
  },
  categoriesError(state) {
    return state.error;
  },
};

const actions = {
  [FETCH_CATEGORIES](context) {
    context.commit(SET_CATEGORIES_LOADING, true);
    context.commit(SET_CATEGORIES_ERROR, null);

    return new Promise((resolve, reject) => {
      ApiService.query("/categories")
        .then(({ data }) => {
          context.commit(SET_CATEGORIES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(
            SET_CATEGORIES_ERROR,
            response?.data?.message || "خطا در دریافت لیست دسته‌بندی‌ها"
          );
          reject(response);
        })
        .finally(() => {
          context.commit(SET_CATEGORIES_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_CATEGORIES](state, categories) {
    state.categories = categories;
  },
  [SET_CATEGORIES_LOADING](state, status) {
    state.loading = status;
  },
  [SET_CATEGORIES_ERROR](state, message) {
    state.error = message;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
